import api from './client'

interface AuthResponse {
  user_id: number
  access_token: string
  refresh_token: string
  is_new_user: boolean
  email?: string
  display_name?: string
  avatar_url?: string
  telegram_linked: boolean
  is_admin: boolean
  role: string
}

interface RegisterData {
  email: string
  password: string
  name?: string
  birth_date?: string  // YYYY-MM-DD
  gender?: 'male' | 'female' | 'other' | 'prefer_not_to_say'
}

interface RegisterResponse {
  email: string
  requires_verification: boolean
  message: string
}

export interface ForgotPasswordResponse {
  success: boolean
  message: string
  auth_provider: string | null  // "email", "google", "telegram" or null if not found
}

interface LoginData {
  email: string
  password: string
}

interface TelegramAuthData {
  id: number
  first_name: string
  last_name?: string
  username?: string
  photo_url?: string
  auth_date: number
  hash: string
}

export async function register(data: RegisterData): Promise<RegisterResponse> {
  const response = await api.post<RegisterResponse>('/auth/register', data)
  return response.data
}

export async function login(data: LoginData): Promise<AuthResponse> {
  const response = await api.post<AuthResponse>('/auth/login', data)
  return response.data
}

export async function telegramLogin(data: TelegramAuthData): Promise<AuthResponse> {
  const response = await api.post<AuthResponse>('/auth/telegram', data)
  return response.data
}

export async function googleLogin(credential: string): Promise<AuthResponse> {
  const response = await api.post<AuthResponse>('/auth/google', { credential })
  return response.data
}

export async function refreshTokens(refreshToken: string): Promise<{
  access_token: string
  refresh_token: string
}> {
  const response = await api.post('/auth/refresh', {
    refresh_token: refreshToken,
  })
  return response.data
}

export async function logout(refreshToken: string): Promise<void> {
  await api.post('/auth/logout', { refresh_token: refreshToken })
}

export async function verifyEmail(code: string, email: string): Promise<void> {
  await api.post('/auth/verify-email', { code, email })
}

export async function resendVerification(email: string): Promise<void> {
  await api.post('/auth/resend-verification', { email })
}

export async function forgotPassword(email: string): Promise<ForgotPasswordResponse> {
  const response = await api.post<ForgotPasswordResponse>('/auth/forgot-password', { email })
  return response.data
}

export async function resetPassword(email: string, code: string, newPassword: string): Promise<void> {
  await api.post('/auth/reset-password', {
    email,
    code,
    new_password: newPassword,
  })
}
